/**
 * Function `getExcerpt` shorten the text to specific word count
 *
 * @function getExcerpt
 * @param {String, Number} - input text, max word count
 * @returns {String} - excerpt text
 */
export const getExcerpt = (text: string, maxWords: number) =>
  text
    .toString()
    .replace(new RegExp(`(([^\\s]+\\s\\s*){${maxWords}})(.*)`), '$1…')
    .trim();
